import * as yup from 'yup';


export const quoteFormValidationSchema = yup.object().shape({
  reference: yup.string().min(1).max(16).defined().required(),
  amountUntaxed:  yup.number().required().max(300000.00).min(1.00),
  amount: yup.number().required().max(300000.00).min(1.00),

}, [])

export interface QuoteModalForm {
  reference: string
  amount: number
  amountUntaxed: number
}

